/**
 * Synchronous string lookup used in non-reactive code paths.
 *
 * For Svelte components, prefer the reactive `$_` store directly from
 * `svelte-i18n` (auto-subscribes to locale changes). This shim exists for
 * places where reading once is enough (e.g. building a URL inside an event
 * handler).
 */
import { get } from 'svelte/store';
import { _ } from 'svelte-i18n';

export function messageForKey(key: string): string {
	const t = get(_);
	if (typeof t !== 'function') return key;
	return t(key);
}
